import type { Gallery } from '@/types/gallery';
import { getBlobUrl } from '@/lib/blob';

export const FACILITY_GALLERIES: Gallery[] = [
  {
    id: 'reception',
    name: 'page.about.facilities.sections.reception.title',
    description: 'page.about.facilities.sections.reception.description',
    images: [
      { src: getBlobUrl('images/facilities/reception.jpg') },
    ],
  },
  {
    id: 'treatment-rooms',
    name: 'page.about.facilities.sections.treatment-rooms.title',
    description: 'page.about.facilities.sections.treatment-rooms.description',
    images: [
      { src: getBlobUrl('images/facilities/treatment-rooms-01.jpg') },
      { src: getBlobUrl('images/facilities/treatment-rooms-02.jpg') },
      { src: getBlobUrl('images/facilities/treatment-rooms-03.jpg') },
      { src: getBlobUrl('images/facilities/treatment-rooms-04.jpeg') },
    ],
  },
  {
    id: 'sterilization',
    name: 'page.about.facilities.sections.sterilization.title',
    description: 'page.about.facilities.sections.sterilization.description',
    images: [
      { src: getBlobUrl('images/facilities/sterilization.jpg') },
    ],
  },
  {
    id: 'waiting-area',
    name: 'page.about.facilities.sections.waiting-area.title',
    description: 'page.about.facilities.sections.waiting-area.description',
    images: [
      { src: getBlobUrl('images/facilities/waiting-area.jpg') },
    ],
  },
  {
    id: 'dental-laboratory',
    name: 'page.about.facilities.sections.dental-laboratory.title',
    description: 'page.about.facilities.sections.dental-laboratory.description',
    images: [
      { src: getBlobUrl('images/facilities/dental-laboratory-01.jpg') },
      { src: getBlobUrl('images/facilities/dental-laboratory-02.jpg') },
      { src: getBlobUrl('images/facilities/dental-laboratory-03.jpg') },
    ],
  },
  {
    id: 'updent-training-centre',
    name: 'page.about.facilities.sections.updent-training-centre.title',
    description: 'page.about.facilities.sections.updent-training-centre.description',
    images: [
      { src: getBlobUrl('images/facilities/updent-training-centre-01.jpg') },
      { src: getBlobUrl('images/facilities/updent-training-centre-02.jpg') },
      { src: getBlobUrl('images/facilities/updent-training-centre-03.jpg') },
    ],
  },
];
